import Rest from './rest';

const RESOURCE = "order";

export default {

    list: function (params) {
        return Rest.get(RESOURCE, {params});
    },

    update: function (orderId, data) {
        return Rest.post(`${RESOURCE}/${orderId}`, data);
    },

    updateClient: function (orderId, data) {
        return Rest.post(`${RESOURCE}/${orderId}/client`, data);
    },

    downloadExcel: function (params) {
        return Rest.downloadExcel(`${RESOURCE}/excel`, null, {params});
    },
};



// WEBPACK FOOTER //
// ./src/services/OrderService.js